<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row mb-4">
                    <h4 class="float-left">Сгруппированная статистика</h4>
                    <feather-icon
                        @click="showPopup()"
                        icon="HelpCircleIcon"
                        class="text-info vopros cursor-pointer page-description"
                        svgClasses="w-5 h-5"
                    />
                </div>
                <vs-popup title="Подробнее" v-if="popupContent" :active.sync="popupIsVisible"><span v-html="popupContent"></span></vs-popup>
            </vs-col>
        </vs-row>

        <div class="vx-row mb-2">
            <div class="vx-col w-5/6">
                <label class="vs-input--label"> Пользователи </label>
                <v-select
                    multiple
                    :options="dicts.users"
                    label="email"
                    placeholder="Выберите пользователей"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.users }"
                    v-model="form.users"
                >
                </v-select>
            </div>
            <div class="vx-col">
                <label class="vs-input--label"> На странице </label>
                <v-select
                    :options="dicts.pageSizes"
                    label="name"
                    placeholder="На странице..."
                    class="w-full"
                    v-model="pageSize"
                    :clearable="false"
                    @input="loadStatistic()"
                >
                </v-select>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-1 w-1/3">
                <label class="vs-input--label"> Страна </label>
                <v-select
                    :options="dicts.countries"
                    multiple
                    label="name"
                    value="iso2"
                    placeholder="Выберите страну"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.countryId }"
                    v-model="form.countries"
                    :reduce="(a) => a.iso2"
                >
                </v-select>
            </div>
            <div class="vx-col w-1/5">
                <label class="vs-input--label"> Дата </label>
                <date-picker
                    :not-before="disabledBefore"
                    :not-after="disabledAfter"
                    v-model="form.statisticDate"
                    value-type="format"
                    format="YYYY-MM-DD"
                    placeholder="Выберите дату"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>
            <div class="vx-col mb-1 w-1/5">
                <label class="vs-input--label"> Brand type </label>
                <v-select
                    :options="dicts.brandTypes"
                    disabled
                    :clearable="false"
                    class="w-full"
                    v-bind:class="{ 'select-error': !!errors.countryId }"
                    v-model="form.brandType"
                >
                </v-select>
            </div>
            <div class="vx-col w-1/6">
                <vs-button class="mt-5" color="success" @click="loadStatistic()" type="filled"> Применить </vs-button>
            </div>
        </div>

        <div class="vx-row mt-1"></div>

        <vs-table :data="statistic" max-items="10" class="mt-5" @sort="handleSort">
            <template slot="thead">
                <vs-th sort-key="adId"> Id Объявления </vs-th>
                <vs-th sort-key="countryName"> Страна </vs-th>
                <vs-th sort-key="clicksCount"> Кол-во кликов </vs-th>
                <vs-th sort-key="clickPriceSumUsd"> Расход </vs-th>
                <vs-th sort-key="statisticDate"> Дата </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td
                        ><router-link :to="{ name: 'ad-edit', params: { id: tr.adId } }" target="_blank">{{ tr.adId }}</router-link></vs-td
                    >
                    <vs-td>{{ tr.countryName }}</vs-td>
                    <vs-td>{{ tr.clicksCount }}</vs-td>
                    <vs-td>{{ tr.clickPriceSumUsd }}</vs-td>
                    <vs-td>{{ tr.createdAt | moment('DD.MM.YYYY') }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';

const disabledBefore = new Date(2022, 1, 10); // Дата начала сбора статистики
const disabledAfter = new Date().setDate(new Date().getDate() - 1); // Максимальный период до вчерашней даты

export default {
    name: 'adCountryStatistic',
    data() {
        return {
            disabledBefore: disabledBefore,
            disabledAfter: disabledAfter,

            popupIsVisible: false,
            popupContent: '',

            page: 1,
            pageSize: 100,
            pagesTotal: 1,

            statistic: [],
            form: {
                statisticDate: undefined,
                sspType: { label: 'Все', value: '0' },
                brandType: { label: 'AdProfex', value: '3' },
                countries: [],
                users: [],
                orderBy: undefined,
                isOrderAsc: false
            },
            errors: {
                name: '',
                status: null
            },
            dicts: {
                users: [],
                countries: [],
                brandTypes: [],
                pageSizes: [5, 25, 50, 100, 500]
            }
        };
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([this.axios.get('countries'), this.axios.get('users')])
                .then(
                    axios.spread((countries, users) => {
                        this.dicts.users = users.data;
                        this.dicts.countries = countries.data;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadStatistic() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                brandTypeIds: [this.form.brandType.value],
                statisticDate: this.form.statisticDate,
                page: this.page,
                size: this.pageSize,
                userIds: this.form.users.map((user) => user.id),
                countriesIso2: this.form.countries,
                orderBy: this.form.orderBy,
                isOrderAsc: this.form.isOrderAsc
            };

            this.axios
                .all([
                    this.axios.get('adCountryStatistic', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    }),
                    this.axios.get('adCountryStatistic/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((statistic, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.statistic = statistic.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки статистики.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        handleSort(key, active) {
            this.orderBy = key;

            if (active == 'asc') this.isAscOrder = true;
            if (active == 'desc') this.isAscOrder = false;

            this.loadStatistic();
        },
        showPopup() {
            this.popupContent = 'Данные собираются каждую ночь за полные прошедшие сутки.<br />'.concat(
                'Для пользователей AdProfex.<br />',
                'Данные хранятся за последние 12 месяцев.'
            );
            this.popupIsVisible = true;
        },
        setDefaultValues() {
            let d = new Date();
            let yesterday = this.$moment(d.setDate(d.getDate() - 1)).format('YYYY-MM-DD');
            this.form.statisticDate = yesterday;
        }
    },
    mounted() {
        this.loadData();
        this.setDefaultValues();
        this.loadStatistic();
    },
    watch: {
        page: function () {
            this.loadStatistic();
        }
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Сгруппированная статистика';
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}

.change-category {
    width: 200px;
}

.page-description {
    margin-left: 10px;
}
</style>
<style scoped>
tr >>> .vs-table--td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;

    font-family: sans-serif;
    font-size: 16px;
}
div >>> .vs-pagination-primary {
    margin-top: 10px;
}
</style>